import React from 'react';
import { LoadingIcon } from '@chegg-ui/theme';
import { LegalCopy } from './LegalCopy';
import { PROCESSING_PAPER_COPY } from '../constants';
import styled from 'styled-components';
var Overlay = styled.div.withConfig({
  componentId: "sc-1fugm94-0"
})(["position:absolute;z-index:20;background-color:rgba(255,255,255);display:flex;flex-direction:column;justify-content:center;align-items:center;top:0px;height:100%;width:100%;"]);
var Pushup = styled.div.withConfig({
  componentId: "sc-1fugm94-1"
})(["height:20%;"]);
var LoadingOverlay = function LoadingOverlay(_ref) {
  var uploading = _ref.uploading,
    displayLegal = _ref.displayLegal,
    children = _ref.children,
    iconAttributes = _ref.iconAttributes;
  if (!uploading) return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LoadingIcon, {
    svgColor: iconAttributes.iconColor,
    size: "large"
  })), /*#__PURE__*/React.createElement("h3", null, PROCESSING_PAPER_COPY), /*#__PURE__*/React.createElement(Pushup, null), displayLegal && /*#__PURE__*/React.createElement(LegalCopy, {
    bottom: true
  })), children);
};
export default LoadingOverlay;